export default __webpack_public_path__ + "static/alastair2-fc360fbdd34a6ff9ee112c4ccbbf40e2.svg";